module.exports = __webpack_public_path__ + "fontawesome-webfont-dfb02f8f6d0cedc009ee5887cc68f1f3.woff";